module.exports = __webpack_public_path__ + "static/media/image-card-2.d8d2b582.png";